import { JSX } from 'react'

import { IconProps } from '../../icon'

const Play: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M33.6113 20.6891L17.3516 8.637C16.8921 8.28311 16.3417 8.0668 15.7642 8.01315C15.1867 7.9595 14.6058 8.07073 14.089 8.33391C13.4342 8.68696 12.8915 9.21664 12.5228 9.86273C12.1541 10.5088 11.974 11.2454 12.003 11.9888V36.093C11.9889 36.8196 12.1743 37.5362 12.5389 38.1648C12.9035 38.7935 13.4335 39.3102 14.0712 39.6587C14.5 39.8837 14.9775 40.0001 15.4618 39.9975C16.1352 40.0247 16.799 39.8306 17.3516 39.4448L33.6291 27.3927C34.1197 26.9827 34.5143 26.4701 34.7851 25.8909C35.0559 25.3118 35.1962 24.6802 35.1962 24.0409C35.1962 23.4016 35.0559 22.77 34.7851 22.1909C34.5143 21.6117 34.1197 21.0991 33.6291 20.6891H33.6113ZM31.4897 24.5223L15.5688 36.307C15.5583 36.236 15.5583 36.164 15.5688 36.093V11.9888C15.5583 11.9178 15.5583 11.8458 15.5688 11.7748L31.454 23.5595C31.454 23.5595 31.5967 23.7556 31.5967 24.0409C31.6194 24.209 31.5814 24.3796 31.4897 24.5223Z'
      fill='black'
    />
  </svg>
)

export default Play
